import React from 'react';
import RiskCardSelected from '../Cards/RiskCardSelected';
import QuotationCardResult from '../../../reusable/QuotationCardResult';
import { SelectQuotePlaceholder } from './v2/ResultSlotCard.styles';

function SelectedQuotesCardsBackoffice({
  processingQuote,
  type,
  requestInfo,
  riskQuotations,
}) {
  return (
    <>

      {processingQuote === null && type.id === 'res_civile' && (
        <SelectQuotePlaceholder
          data-bs-toggle="modal"
          data-bs-target={`#${type.id}`}
        >
          Seleziona Quotazione!
        </SelectQuotePlaceholder>
      )}
      {processingQuote !== null && type.id === 'res_civile' && (
        <div className="col-12 mb-2">
          <QuotationCardResult
            processingQuote={processingQuote}
            requestInfo={requestInfo}
          />
        </div>
      )}

      {riskQuotations
        && riskQuotations[type.id] !== undefined
        && riskQuotations[type.id].map((quote, idx) => (
          <React.Fragment key={idx}>
            {processingQuote !== null
              && !(type.id === 'res_civile' && processingQuote.company_id === 2)
              && type.id === quote.quote_type && (
                <div className="col-12 mb-2">
                  <RiskCardSelected quote={quote} type={type} requestInfo={requestInfo} />
                </div>
            )}
          </React.Fragment>
        ))}
      {riskQuotations
        && riskQuotations[type.id] === undefined
        && type.id !== 'res_civile'
        && processingQuote !== null && (
          <SelectQuotePlaceholder
            data-bs-toggle="modal"
            data-bs-target={`#${type.id}`}
          >
            Seleziona Quotazione!
          </SelectQuotePlaceholder>
      )}
    </>
  );
}

export default SelectedQuotesCardsBackoffice;
